import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const TagIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M0.771429 8.20369V0.771429H8.20369L17.2286 9.79631L9.79631 17.2286L0.771429 8.20369Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

TagIcon.displayName = 'TagIcon';
